// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"A3-z"};